import styled, { css } from 'styled-components'

import { radius } from '../../../themes'
import type { Layout } from '../styles'

export const ImgContainer = styled.div`
  position: relative;
`

interface ContainerProps {
  split?: boolean
  layout: Layout
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  height: 144px;

  ${({ layout }) =>
    (layout === 'horizontal' || layout === 'horizontal-embedded') &&
    css`
      height: 87px;
      width: 103px;
      min-width: 103px;
      border-radius: ${radius('sm')};
    `}

  & ${ImgContainer} {
    height: 100%;
    width: ${(props) => (props.split ? '50%' : '100%')};
    pointer-events: none;

    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
`
